module.exports = __webpack_public_path__ + "img/28.1.6dc26b2e.jpg";